import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowRight, FiShield } from 'react-icons/fi';
import { motion } from 'framer-motion';

export default function CTABlock({ variant = 'default' }) {
  const navigate = useNavigate();

  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className={`rounded-xl border p-8 md:p-10 ${
        variant === 'dark' 
          ? 'bg-slate-900 border-slate-800 text-white' 
          : 'bg-white border-slate-200 shadow-sm'
      }`}
    >
      <div className="flex flex-col md:flex-row items-center justify-between gap-8">
        <div className="max-w-xl">
          <div className="flex items-center gap-2 mb-4">
            <FiShield className={variant === 'dark' ? 'text-peridot-400' : 'text-peridot-600'} />
            <span className={`text-sm font-semibold tracking-wider uppercase ${variant === 'dark' ? 'text-peridot-400' : 'text-peridot-600'}`}>
              Executive Action
            </span>
          </div>
          <h3 className={`text-2xl font-bold mb-3 ${variant === 'dark' ? 'text-white' : 'text-slate-900'}`}>
            Most enterprises uncover critical AI risks within 30 minutes.
          </h3>
          <p className={variant === 'dark' ? 'text-slate-400' : 'text-slate-600'}>
            Stop guessing your exposure. Get a definitive inventory of every AI tool, model, and shadow application running in your environment. Used by CISOs before board reviews.
          </p>
          <ul className={`mt-4 space-y-2 text-sm ${variant === 'dark' ? 'text-slate-300' : 'text-slate-600'}`}>
            <li className="flex items-center gap-2">✓ No agent deployment required</li>
            <li className="flex items-center gap-2">✓ 48-hour turnaround</li>
            <li className="flex items-center gap-2">✓ Board-ready reporting</li>
          </ul>
        </div>
        
        <div className="w-full md:w-auto shrink-0">
          <button 
            onClick={() => navigate('/ai-governance-audit')}
            className={`w-full md:w-auto group flex items-center justify-center gap-2 px-8 py-4 rounded-lg font-semibold transition-all ${
              variant === 'dark'
                ? 'bg-peridot-500 hover:bg-peridot-400 text-slate-950'
                : 'bg-slate-900 hover:bg-slate-800 text-white'
            }`}
          >
            Request Your AI Governance Audit
            <FiArrowRight className="group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>
    </motion.div>
  );
}